import React, { useContext } from 'react';
import { Button } from 'baseui/button';

import { ModalContext } from 'commons-ui';

import usePermissionV2 from 'commons-ui/src/permission/usePermission';
import { ACTION, PAGE_NAMES, USER_PROFILE_RESOURCES } from 'constant';
import GetTransactionPdfContent from './GetTransactionPdfContent';

const GetTransactionPdf = () => {
	const { setModalConfig } = useContext(ModalContext);

	const { hasPermission: hasPermissionV2 } = usePermissionV2();

	const handleGetTransactionPdf = async () => {
		setModalConfig({
			isOpen: true,
			header: 'Get Transaction Pdf',
			content: <GetTransactionPdfContent />
		});
	};

	return hasPermissionV2({
		configPageName: PAGE_NAMES.userProfile,
		configResourceName: USER_PROFILE_RESOURCES.transactionHistory,
		configActionName: ACTION.getTransactionPdf
	}) ? (
		<Button onClick={handleGetTransactionPdf} size='compact'>
			Get Transaction Pdf
		</Button>
	) : (
		<> </>
	);
};

export default GetTransactionPdf;
